module.exports = __webpack_public_path__ + "static/media/sanskriti pandey.f730390e.jpeg";